<template>
  <timeline-item type="wewnętrzna" :date="message.date_sent">
    <template v-slot:title>
      {{ message.title }}
      <span v-if="message.status === '0'" class="m-badge m-badge--ls">nieprzeczytana</span>
    </template>
    <template v-slot:actions>
      <a class="btn btn-sm m-btn m-btn--pill m-btn--custom btn-outline-ls" @click="openModal">
        Zobacz wiadomość
      </a>

      <b-modal v-model="isModalOpened"
               :title="message.title"
               :ok-only="true"
               centered
               size="lg"
               ok-title="Zamknij"
               ok-variant="default"
               :lazy="true">
        <iframe :srcdoc=message.content
        ></iframe>
      </b-modal>
    </template>
  </timeline-item>
</template>

<script>
import {mapActions} from 'vuex'
import TimelineItem from '@/components/timeline/TimelineItem';

export default {
  name: "InternalMessage",
  components: {TimelineItem},
  props: ['message'],
  data() {
    return {
      isModalOpened: false
    }
  },
  methods: {
    ...mapActions([
      'fetchUser',
      'fetchMessages'
    ]),
    openModal() {
      this.isModalOpened = true;

      if (this.message.status === '0') {
        this.$http.patch(`/messages/${this.message.id}`)
            .then((r) => {
              if (r.data.success) {
                this.fetchUser(); //update unread counter
                this.fetchMessages(); //update messages
              }
            });
      }
    }
  },
}
</script>

<style>

.modal .modal-content .modal-body {
  overflow: auto;
}
iframe{
  height: 600px;
  border: 0;
}

@media (max-height: 800px) {
  iframe{
    height: 400px
  }
}
@media (max-height: 600px) {
  iframe{
    height: 300px
  }
}
</style>
